import type { IDimensionDefinition } from '@feathr/blackbox';
import { ValidDimensions } from '@feathr/blackbox';
import { ValidFacebookDimensions, ValidFacebookVideoDimensions } from '@feathr/blackbox';
import type { ISelectOption } from '@feathr/components';

function mapDimensionsToOptions(dimensions: Record<string, IDimensionDefinition>): ISelectOption[] {
  return Object.keys(dimensions).map<ISelectOption>((key) => {
    const value = dimensions[key];
    return {
      id: value.spec,
      name: value.name,
    };
  });
}

const baseTypeOptions = mapDimensionsToOptions(ValidDimensions);
const facebookTypeOptions = mapDimensionsToOptions(ValidFacebookDimensions);
const facebookVideoTypeOptions = mapDimensionsToOptions(ValidFacebookVideoDimensions);

export function getOptions(hasFacebook: boolean = false): ISelectOption[] {
  const allOptions: ISelectOption[] = [
    ...baseTypeOptions,
    ...facebookTypeOptions,
    ...facebookVideoTypeOptions,
  ];
  if (hasFacebook) {
    return allOptions;
  }
  return baseTypeOptions;
}
